export const ServiceType = Object.freeze({
  1: "NHS",
  2: "Private",
  3: "WalkIn",
});
